<template>
    <div>
        <p class="text-center">
            <i class="fa fa-spinner fa-spin fa-fw" :class="{'fa-4x': !is_small, 'text-white': is_white}"></i>
            <span class="sr-only">Loading...</span>
        </p>
    </div>
</template>

<script>
export default {
    name: "Loading",

    props: {is_small: {type: Boolean, default: false}, is_white: {default: false}},
}
</script>

<style scoped>
/* Text Alignment */
.text-center {
    text-align: center;
}

/* Text Colors */
.text-white {
    color: #ffffff;
}

/* Screen Reader Only */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
</style>
